import { TMessage, TMessageParam } from "@/i18n/tt";
import { useTranslation } from "@/stores/RootStoreContext";
import { classNames } from "@/utils/classNames";
import { HoverTooltip } from "./Tooltip";

export type TextWithTooltipUnderline = "dotted" | "solid" | "none";

export type TextWithTooltipProps = {
  text: TMessage;
  tooltip?: TMessage | TMessageParam;
  underline?: TextWithTooltipUnderline;
  hasNotSet?: boolean;
};

const underlineClassNames: Record<TextWithTooltipUnderline, string | undefined> = {
  dotted: "underline decoration-dotted",
  solid: "underline",
  none: undefined,
};

export function TextWithTooltip({
  text,
  tooltip,
  underline = "dotted",
  hasNotSet,
}: TextWithTooltipProps) {
  const { t } = useTranslation();
  if (!tooltip) {
    return <div className={hasNotSet ? "subtle" : undefined}>{t(text)}</div>;
  }
  return (
    <HoverTooltip content={t(tooltip)}>
      {({ targetRef }) => (
        <span
          ref={targetRef}
          className={classNames(hasNotSet && "subtle", underlineClassNames[underline])}
        >
          {t(text)}
        </span>
      )}
    </HoverTooltip>
  );
}
